<template>
  <div class="balances">
    <div class="balances__tabs">
      <button :class="{ selected: tabToggle === 'watch' }" @click="selectTab('watch')">
        Посмотреть
      </button>
      <button :class="{ selected: tabToggle === 'edit' }" @click="selectTab('edit')">
        Изменить
      </button>
    </div>
    <div class="balances__form">
      <div v-if="tabToggle === 'watch'" class="balances__watch">
        <div class="inputWrapper">
          <span>User Id:</span>
          <input type="text" placeholder="user id" class="userId" v-model="editParams.userId" />
        </div>
        <div class="inputWrapper calendarInput">
          <span>Date:</span>
          <div id="app" class="balances__calendar" v-if="openedCalendar">
            <DatePicker
              v-on:input="getCorrectDate"
              v-bind:value="selectedDate"
              is-dark
              is-range
              :modelConfig="modelConfig"
              :select-attribute="selectDragAttribute"
              :drag-attribute="selectDragAttribute"
              @drag="dragValue = $event"
            >
              <template v-slot:day-popover="{ format }">
                <div>
                  {{ format(dragValue ? dragValue.start : range.start, 'MMM D') }}
                  -
                  {{ format(dragValue ? dragValue.end : range.end, 'MMM D') }}
                </div>
              </template>
            </DatePicker>
          </div>
          <div class="balances__selectedDates" @click="openCalendar">
            <span>{{ valueDate }}</span>
            <button class="clear" @click="clearDate">Очистить</button>
          </div>
        </div>
        <button
          :class="{ balances__submit: true, disable: isSearchBtnDisable }"
          @click="searchChanges"
        >
          Поиск
        </button>
      </div>
      <div v-if="tabToggle === 'edit'" class="balances__edit">
        <div class="inputWrapper">
          <span>User Id:</span>
          <input type="text" placeholder="user id" class="userId" v-model="editParams.userId" />
        </div>
        <div class="inputWrapper">
          <span>Currency:</span>
          <div class="balances__select" @click="toggleSelect('currency')">
            <p>{{ editParams.selectedCurrency }}</p>
            <img
              :class="{ rotate: selectsOpen.currency }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="balances__dropDown" v-if="selectsOpen.currency">
            <span v-for="(type, key) in currencyMap" :key="key" @click="selectCurrency(key)">
              {{ type }}
            </span>
          </div>
        </div>
        <div class="inputWrapper">
          <span>Comment:</span>
          <input type="text" placeholder="Comment" v-model="editParams.comment" />
        </div>
        <div class="inputWrapper" v-if="editParams.selectedCurrency !== 'Выберите валюту'">
          <span
            >Max
            {{
              isCurrentDailyBalance[editParams.selectedCurrency] -
              spentDailyLimit[editParams.selectedCurrency]
            }}
            {{ editParams.selectedCurrency }}</span
          >
          <input
            type="number"
            :placeholder="`Amount ${editParams.selectedCurrency}`"
            v-model="editParams.amount"
          />
        </div>
        <div class="inputWrapper" v-if="editParams.amount && isTimeExceeded">
          <span>2FA</span>
          <input type="number" placeholder="2FA" v-model="editParams.twoFactor" />
        </div>
        <button
          :class="{ disable: isBtnDisable, balances__submit: true }"
          class="balances__change"
          @click="changeBalance"
        >
          Изменить
        </button>
        <div class="balances__limit">
          <p>Лимиты:</p>
          <span>RUB: {{ isCurrentDailyBalance['rub'] - spentDailyLimit['rub'] }}</span>
          <span>USD: {{ isCurrentDailyBalance['usd'] - spentDailyLimit['usd'] }}</span>
          <span>EUR: {{ isCurrentDailyBalance['eur'] - spentDailyLimit['eur'] }}</span>
        </div>
      </div>
      <p v-if="responseSuccess" class="success">Успешно</p>
      <p v-if="responseError" class="error">Ошибка</p>
      <p v-if="responseEmpty" class="error">Записей нет</p>
    </div>
    <div class="balances__logs" v-if="searchedLogs && tabToggle === 'watch'">
      <table>
        <thead>
          <tr>
            <td>User_id</td>
            <td>Date</td>
            <td>inc</td>
            <td>Balance_after</td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(log, key) in searchedLogs"
            :key="key"
            :class="{
              adminChange:
                log.inc.balance_offset_rub ||
                log.inc.balance_offset_eur ||
                log.inc.balance_offset_usd
            }"
          >
            <td>{{ log.user_id }}</td>
            <td>{{ parseDate(log.datetime) }}</td>
            <td class="info changes">
              <span v-if="log.inc.balance_usd">USD: {{ log.inc.balance_usd }}</span>
              <span v-if="log.inc.balance_rub">RUB: {{ log.inc.balance_rub }}</span>
              <span v-if="log.inc.balance_eur">EUR: {{ log.inc.balance_eur }}</span>
            </td>
            <td class="info">
              <span v-for="(type, key) in log.balance_after" :key="key">{{ key }}: {{ type }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import './balances.scss'

import cookie from 'vue-cookie'
import { DatePicker, Calendar } from 'v-calendar'

export default {
  name: 'Balances',
  components: {
    Calendar,
    DatePicker
  },
  data() {
    return {
      tabToggle: 'watch',
      time2fa: localStorage.getItem('time2fa') ? localStorage.getItem('time2fa') : null,
      editParams: {
        userId: '',
        selectedCurrency: 'Выберите валюту',
        comment: '',
        amount: '',
        twoFactor: ''
      },
      dragValue: null,
      range: {
        start: new Date(2018, 0, 8),
        end: new Date(2018, 0, 12)
      },
      modelConfig: {
        type: 'string',
        mask: 'iso'
      },
      selectedDate: new Date(),
      currencyMap: {
        rub: '₽',
        usd: '$',
        eur: '€'
      },
      startDate: '',
      endDate: '',
      valueDate: 'Выберите дату',
      selectsOpen: {
        currency: false
      },
      spentDailyLimit: {},
      searchedLogs: null,
      openedCalendar: false,
      responseSuccess: false,
      responseError: false,
      responseEmpty: false,
      btnDisable: false
    }
  },
  computed: {
    isTimeExceeded() {
      if (!this.time2fa) {
        return true // Если нет сохраненного времени, показываем поле
      }
      const currentTime = new Date()
      const savedDate = new Date(this.time2fa)
      const tenMinutesLater = new Date(savedDate.getTime() + 10 * 60000) // Добавляем 10 минут к сохраненному времени

      return currentTime > tenMinutesLater // Проверяем, больше ли текущее время на 10 минут
    },
    selectDragAttribute() {
      return {
        popover: {
          visibility: 'hover',
          isInteractive: false
        }
      }
    },
    isBtnDisable() {
      if (
        !this.editParams.userId ||
        this.editParams.selectedCurrency === 'Выберите валюту' ||
        !this.editParams.comment ||
        !this.editParams.amount ||
        this.btnDisable ||
        (this.isTimeExceeded && !this.editParams.twoFactor)
      ) {
        return true
      } else {
        return false
      }
    },
    isSearchBtnDisable() {
      if (!this.editParams.userId || this.valueDate === 'Выберите дату') {
        return true
      } else return false
    },
    isCurrentDailyBalance() {
      return this.$store.state.currentBalanceLimit
    }
  },
  mounted() {
    this.getDailyLimitBalance()
  },
  created() {
    this.initListeners()
  },
  destroyed() {
    this.initListeners()
  },
  methods: {
    selectTab(tab) {
      this.tabToggle = tab
      this.clearParams()
    },
    toggleSelect(select) {
      this.selectsOpen[select] = !this.selectsOpen[select]
    },
    selectCurrency(cur) {
      this.editParams.selectedCurrency = cur
      this.selectsOpen.currency = false
    },
    searchChanges() {
      this.searchedLogs = null
      fetch(
        `https://auth.apineural.com/api/user/admin-balance?user_id=${this.editParams.userId}${this.startDate}${this.endDate}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${this.$store.state.tokens.access}`
          }
        }
      )
        .then((res) => res.json())
        .then((data) => {
          if (!data.logs.length) {
            this.responseEmpty = true
            setTimeout(() => {
              this.responseEmpty = false
            }, 2000)
          } else {
            this.searchedLogs = data.logs
          }
        })
    },
    getDailyLimitBalance() {
      fetch(`https://auth.apineural.com/api/user/admin-balance?sum=""`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.$store.state.tokens.access}`
        }
      })
        .then((res) => res.json())
        .then((data) => {
          this.spentDailyLimit = data
        })
    },
    parseDate(date) {
      const d = new Date(date)

      d.setMinutes(d.getMinutes() + -d.getTimezoneOffset())

      return d.toLocaleString('ru-RU', {
        timeZone: 'Europe/Moscow',
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
      })
    },
    changeBalance() {
      const body = {
        user_id: this.editParams.userId,
        amount: {
          rub: 0,
          usd: 0,
          eur: 0
        },
        comment: this.editParams.comment,
        code: this.editParams.twoFactor
      }
      body.amount[this.editParams.selectedCurrency] = Number(this.editParams.amount)
      this.btnDisable = true
      fetch('https://auth.apineural.com/api/user/admin-balance', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${cookie.get('token')}`
        },
        body: JSON.stringify(body)
      })
        .then((res) => res.json())
        .then((data) => {
          this.btnDisable = false
          if (data.status) {
            this.spentDailyLimit[this.editParams.selectedCurrency] += Math.abs(
              this.editParams.amount
            )
            if (this.editParams.twoFactor) {
              localStorage.setItem('time2fa', new Date().toISOString())
              this.time2fa = new Date().toISOString()
            }
            this.clearParams()
            this.responseSuccess = true
            setTimeout(() => {
              this.responseSuccess = false
            }, 2000)
          } else {
            this.responseError = true
            this.time2fa = null
            localStorage.removeItem('time2fa')
            setTimeout(() => {
              this.responseError = false
            }, 2000)
          }
        })
    },
    getCorrectDate(e) {
      this.startDate = `&start=${e.start.split('.')[0]}`
      this.endDate = `&end=${e.end.split('.')[0]}`
      this.valueDate = `${e.start.split('T')[0]} - ${e.end.split('T')[0]}`
      this.openedCalendar = false
    },
    openCalendar(event) {
      const path = event.path || (event.composedPath && event.composedPath())
      if (event && path.find((button) => button.classList && button.classList.contains('clear'))) {
      } else {
        this.openedCalendar = true
      }
    },
    clearDate() {
      this.startDate = ''
      this.endDate = ''
      this.valueDate = 'Выберите дату'
    },
    clearParams() {
      this.editParams = {
        userId: '',
        selectedCurrency: 'Выберите валюту',
        amount: '',
        twoFactor: ''
      }
    },
    closeByClickingSelect(event) {
      const path = event.path || (event.composedPath && event.composedPath())
      if (
        event &&
        !path.find(
          (div) =>
            div.classList &&
            (div.classList.contains('balances__select') || div.classList.contains('calendarInput'))
        )
      ) {
        this.selectsOpen.currency = false
        this.openedCalendar = false
      }
    },
    initListeners() {
      document.addEventListener('click', this.closeByClickingSelect)
    }
  }
}
</script>
